"use client";
import {
  tag
} from "./chunk-XBUS7HMU.mjs";

// src/components/atoms/Tag/Tag.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Tag = forwardRef(function Tag2({
  text = "Eu sou uma tag",
  color,
  direction
}, ref) {
  return /* @__PURE__ */ jsx("div", { ref, className: tag({ color, direction }), children: text });
});
var Tag_default = Tag;

export {
  Tag_default
};
